import { defineComponent } from "vue";
import { Container } from "aurelia-dependency-injection";

import { BranchesService } from "../../../../../services/branches-service";
import { PatientStatus } from "../../../../../enums/PatientStatusEnum";

import HCPatientMain from "../HCPatientMain/HCPatientMain.vue";

export default defineComponent({
    components: {
        HCPatientMain
    },
    props: {
        selectedPatientDetails: {
            default: null
        }
    },
    data(vm) {
        return { _branchesService: null as BranchesService, allBranches: [], statusEnum: PatientStatus };
    },
    async created() {
        this._branchesService = Container.instance.get(BranchesService);
        this.allBranches = await this._branchesService.getAllBranches();
    },
    computed: {
        getBranchName() {
            return this.allBranches.find((branch) => branch.id === this.selectedPatientDetails?.agencyLocationId);
        }
    }
});
